import { AbstractCommand } from './AbstractCommand';
import { CommandResponse } from '../types';
import { getSequenceId } from '../utils/sequenceIdManager';

export class SetBedTempCommand extends AbstractCommand {
  public readonly category = 'print';
  public readonly command = 'gcode_line' as const;

  constructor(
    private temperature: number
  ) {
    super({
      ctrl_type: 'bed_temp',
      value: temperature
    });
  }

  toJSON(): object {
    return {
      print: {
        command: 'gcode_line',
        sequence_id: getSequenceId().toString(),
        gcode: `M140 S${this.temperature}`
      }
    };
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    if (!('print' in response)) {
      return false;
    }

    const printResponse = response as { print: { sequence_id?: string | undefined } };
    const responseId = printResponse.print?.sequence_id;
    const extraId = this.extra?.sequence_id;

    if (!responseId) {
      return false;
    }

    if (sequence_id && responseId === sequence_id) {
      return true;
    }

    if (extraId && responseId === extraId) {
      return true;
    }

    return false;
  }
}